import update from 'immutability-helper'
import {
  SET_GROUPS,
  CREATE_GROUPS,
  UPDATE_GROUPS,
  DELETE_GROUPS
} from 'constants/ActionTypes'

const initialState = []

export default function (state = initialState, action) {
  let index = -1
  switch (action.type) {
    case SET_GROUPS:
      return action.payload
    case CREATE_GROUPS:
      return [...state, action.payload]
    case UPDATE_GROUPS:
      index = state.findIndex(i => action.payload._id === i._id)
      if (index > -1) {
        return update(state, {
          [index]: { $set: { ...state[index], ...action.payload } }
        })
      }
      break
    case DELETE_GROUPS:
      index = state.findIndex(i => action.payload._id === i._id)
      if (index > -1) {
        return update(state, { $splice: [[index, 1]] })
      }
      break
    default:
      return state
  }
  return state
}
